<template>
  <div class="image-checkbox-group">
    <div v-for="option in options" :style="style" :key="option.value" class="image-checkbox-option" :class="{ disabled: disabled }" @click="toggleOption(option.value)">
      <img :style="{ width: style.imgWidth, height: style.imgHeight, borderRadius: style.imgRadius }" :src="option.optionUrl" :alt="option.label" class="option-image" />
      <div class="option-label">{{ option.label }}</div>
      <input type="checkbox" :style="getSelectStyle" :disabled="disabled" :value="option.value" :checked="isChecked(option.value)" @change.stop class="checkbox-input" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { computeRatioPx } from '@/packages/plugins/utils'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  options: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean
  },
  style: {
    type: Object,
    default: () => {}
  }
})

const emit = defineEmits(['change', 'update:modelValue'])

// 获取选择框变量样式
const getSelectStyle = computed(() => {
  return {
    '--select-bg': props.style.selectBg,
    '--selected-bg': props.style.selectedBg,
    '--selected-mark': props.style.selectMark,
    '--border-color': props.style.selectBorderColor,
    '--selected-font-size': computeRatioPx(22),
    '--selected-bottom': computeRatioPx(2),
    border: `${computeRatioPx(2)} solid var(--border-color)`,
    width: computeRatioPx(28),
    height: computeRatioPx(28)
  }
})

const isChecked = (value) => {
  return props.modelValue.includes(value)
}

const toggleOption = (value) => {
  if (props.disabled) {
    return
  }
  let newValue = [...props.modelValue]
  if (isChecked(value)) {
    newValue = newValue.filter((v) => v !== value)
  } else {
    newValue.push(value)
  }
  emit('change', newValue)
  emit('update:modelValue', newValue)
}
</script>

<style scoped>
.image-checkbox-group {
  display: flex;
  flex-direction: column;
  /* gap: 0.8571rem; */
}

.image-checkbox-option {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
  width: max-content;
  max-width: 100%;
  box-sizing: border-box;
}

/* .image-checkbox-option:hover {
  border-color: #409eff;
}

.image-checkbox-option.selected {
  border-color: #409eff;
  background-color: #f0f7ff;
} */

.image-radio-option.disabled {
  cursor: not-allowed;
  border-color: #ccc;
  background-color: #f5f5f5;
}

.image-radio-option.disabled:hover {
  border-color: #ccc;
}

.option-image {
  width: 100%;
  height: 5.7143rem;
  object-fit: cover;
  border-radius: 0.2857rem;
}

.option-label {
  text-align: center;
  overflow-wrap: break-word;
  white-space: normal;
  /* width: 100%; */
  padding: 0 0.2857rem;
}

.checkmark {
  position: absolute;
  top: 0.2857rem;
  right: 0.2857rem;
  width: 1.4286rem;
  height: 1.4286rem;
  background-color: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8571rem;
}

.checkbox-input {
  /* 新增 */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  position: relative;
  cursor: pointer;
  border-radius: 0.14286rem;
  background: var(--select-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox-input:checked {
  background: var(--selected-bg);
}

.checkbox-input:checked::before {
  content: '✓';
  font-size: var(--selected-font-size);
  color: var(--selected-mark);
  position: relative;
  bottom: var(--selected-bottom);
}
</style>
